import { createCustomSlice } from 'core/utils';

const initialState = {
    absenceRate: {},
    absenceRateLoading: false,
    absenceRateProcessing: false,
    absenceRateUpserted: false,
    configurations: {},
    error: '',
    result: false,
    scheduleConfigUpsert: false,
    scheduleCreation: false,
    scheduleCreationError: '',
    scheduleUpdateError: '',
    schedules: [],
    uploading: false,
    uploadingLogo: false,
    uploadingLogoError: '',
    uploadingLogoProcessing: false
};

const configurationSlice = createCustomSlice({
    initialState,
    name: 'configuration',
    reducers: {
        replaceConfiguration (state, { payload }) {
            state.configurations = { ...state.conconfigurations, ...payload };
        }
    },
    saga: [
        'getAbsenceRateConfiguration',
        'getConfigurations',
        'getAbsenceRateSchedules',
        'updateAbsenceRateConfiguration',
        'updateGlobalConfig',
        'uploadFile',
        'uploadLogoFile',
        'upsertAbsenceRateConfiguration',
        'upsertAbsenceRateSchedule',
        'upsertAbsenceRateScheduleConfig',
        'upsertSpecialDay'
    ]
});

const parseDailyHours = (list = []) => list.map(({
    day_of_week,
    hours,
    label
}) => ({
    day: day_of_week,
    label,
    working_hours: hours ?? null
}));

const parseWorkplaces = (list = []) => list.map(({
    employees,
    id,
    name,
    workplace_employees
}) => ({
    employees: employees ?? null,
    name,
    workplace_employees,
    workplace_id: id
}));

export const parseAbsenceRateSchedules = (list = []) => list.map(({
    id,
    name,
    ...e
}) => ({
    ...e,
    key: id,
    label: name
}));

export const parseAbsenceRate = e => {
    const { daily_hours, workdays, workplaces } = e;
    return {
        ...e,
        ...(!!daily_hours && { daily_hours: parseDailyHours(daily_hours) }),
        workdays: workdays ?? null,
        workplaces: parseWorkplaces(workplaces)
    };
};

export const configurationActions = configurationSlice.actions;

export default configurationSlice.reducer;
